/**
 * Navigation utilities
 */

export const reloadPage = (): void => {
  window.location.reload();
};

export const navigateTo = (url: string): void => {
  window.location.assign(url);
};
